export default __webpack_public_path__ + "static/media/factory__25.bbda3ebe.jpg";